import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { useEffect, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { useSelector } from "react-redux";

const StyledTooltip = withStyles({
  tooltip: {
    color: "black",
    backgroundColor: "white",
    border: "1px solid #E6E8ED",
    fontSize: 14,
  },
  arrow: {
    color: "white",
    "&:before": {
      border: "1px solid #E6E8ED",
    },
  }
})(Tooltip);

export default function RequiredDocsTooltip(props) {
  const [tooltipTitle, setTooltipTitle] = useState("");  
  const requiredDocsByFieldName = useSelector((state) => state.lenderRequestReducer.requiredDocsByFieldName);
  
  useEffect(() => {
    if (props.fieldname && requiredDocsByFieldName) {
      const requiredDocs = requiredDocsByFieldName[props.fieldname]?.map(doc => doc.name);

      if (props.consoleWarn) {
        if (!requiredDocsByFieldName[props.fieldname]) {
          console.warn('DocTypeTooltip - no entry in requiredDocsByFieldName for fieldname', props.fieldname, requiredDocsByFieldName);
        }

        if (!requiredDocs?.length) {
          console.warn('DocTypeTooltip - no required documents found for fieldname', props.fieldname);
        }
      }

      const title = requiredDocs?.length
        ? `Fannie Mae requires the following documentation to edit this field: ${requiredDocs.join(", ")}`
        : "Fannie Mae does not require additional documentation to edit this field.";

      setTooltipTitle(title);
    } else if (props.title) {
      setTooltipTitle(props.title);
    }
  }, [requiredDocsByFieldName]);
                                                
  return (
    <StyledTooltip       
      {...props}
      title={tooltipTitle}
      placement="top"
    >
      <div className="req-info"> 
        <FaInfoCircle />
      </div>
    </StyledTooltip>
  );
};